import { Link } from 'react-router-dom'
import { Waterline } from '../components/Waterline'

export function Services() {
  return (
    <>
      <section className="section prose">
        <div className="wrap">
          <p className="eyebrow">Services</p>
          <h1>One service, done thoroughly.</h1>
          <p className="lede">
            Loonworks builds custom websites for Minnesota small businesses,
            operations included. That one sentence covers more ground than
            it sounds like.
          </p>

          <h2>Operations first, software second</h2>
          <p>
            The work starts with how your business actually runs: who does
            what, what gets written down where, which tools already carry
            part of the load. Plenty of off-the-shelf software is genuinely
            good, and where a subscription tool fits your business, you
            should keep using it.
          </p>
          <p>
            Custom software belongs where your business doesn't match the
            mold: the scheduling that follows your rules, the quoting that
            matches how you price, the approvals that mirror how you
            delegate. Loonworks builds those parts and makes them fit
            alongside the tools worth keeping.
          </p>

          <h2>The site your customers see</h2>
          <p>
            The public website, designed and written for your business, not
            assembled from a theme. Fast, readable on a phone, and easy to
            find in search. It's built with the same care behind the scenes as
            in front, so it stays easy to change as the business changes.
          </p>

          <h2>Payments and checkout</h2>
          <p>
            Take money on your own site: checkout, receipts, and order records
            that match how you actually sell. Built on Stripe, the same
            payment platform used by companies of every size.
          </p>

          <h2>Admin tools and workflows</h2>
          <p>
            The counter side of the website, and usually the reason people
            call: scheduling, job tracking, order queues, customer records,
            content you can edit yourself, and the small workflows that eat
            your week. Built for the person who will actually use them, not
            for a demo.
          </p>

          <h2>Hosting without lock-in</h2>
          <p>
            Every client's site runs in its own AWS account (Amazon's cloud,
            the same infrastructure much of the internet runs on), separate
            from every other client. Loonworks sets the account up, keeps it
            healthy, and bills the hosting as part of the service, so you
            never touch a cloud console. Hosting is not just servers,
            either: it includes keeping the site itself current and watched,
            so it never becomes the aging system nobody updates.
          </p>
          <p>
            And if we ever part ways, the whole account transfers to you:
            code, data, domain, everything. Any developer can take it from
            there.
          </p>
        </div>
      </section>

      <Waterline />

      <section className="section">
        <div className="wrap">
          <p className="eyebrow">Fit</p>
          <h2>Is this you?</h2>
          <div className="fit-grid">
            <div>
              <h3>A good fit</h3>
              <ul>
                <li>
                  You built on Wix, Squarespace, or a template and hit the
                  wall: the site can't do what the business needs.
                </li>
                <li>
                  Your operations are specific: custom orders, scheduling,
                  approvals, inventory, member records.
                </li>
                <li>
                  The business runs on spreadsheets and a stack of
                  subscriptions that don't talk to each other.
                </li>
                <li>
                  Your current site runs on an aging system and a pile of
                  plugins nobody is updating, and that's started to worry
                  you.
                </li>
              </ul>
            </div>
            <div>
              <h3>Probably not</h3>
              <ul>
                <li>
                  You need a simple brochure page. A template builder is
                  cheaper and genuinely fine for that.
                </li>
                <li>
                  You're looking for a large agency. Loonworks is a small
                  studio, kept that way on purpose.
                </li>
                <li>
                  You're shopping for the lowest bid. Careful custom work is
                  not the cheapest option, and it shouldn't be.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section cta-band">
        <div className="wrap">
          <h2>Sound like your situation?</h2>
          <Link to="/contact" className="button button--primary">
            Tell me about your business
          </Link>
        </div>
      </section>
    </>
  )
}
